import { z } from "zod";

import { defineEvents } from "~/analytics/factory";

/** Namespace: "create-account-wizard" — same shape as onboarding wizard where applicable. */
export const events = defineEvents("create-account-wizard", {
  started: z.object({}),
  intro_completed: z.object({}),
  step_completed: z.object({
    from_step: z.string(),
    to_step: z.string(),
  }),
  step_back: z.object({
    from_step: z.string(),
    to_step: z.string(),
  }),
  step_validation_failed: z.object({
    step: z.string(),
  }),
  submit_started: z.object({
    industry: z.string().optional(),
    currency: z.string().optional(),
    timezone: z.string().optional(),
  }),
  submit_succeeded: z.object({
    account_id: z.string(),
  }),
  submit_failed: z.object({}),
});
